import _ from 'lodash';
import DepsService from 'services/dependencies';

// eslint-disable-next-line no-undef
@Inject('HttpService', '$state')
class ErrorService {
  initialize(config) {
    this.config = config;
    this.HttpService.overwrite('errorFn', this.handleHttpError.bind(this));
  }

  getErrorCode(error) {
    const errorObj = error.data.errors || error.data.globalErrors || error.data.fieldErrors;
    const errorCode = _.get(errorObj, '[0].code') || this.config.errorCodes.ENTITY_DOES_NOT_EXIST;

    return errorCode;
  }

  setErrorCode(error, errorCode) {
    const err = _.set(error, 'data.errors[0].code', errorCode);

    return err;
  }

  handleHttpError(err, context) {
    const status = _.get(err, 'status') || 'None';
    const errorStatusCb = _.get(this, `errorStatus${status}`) || this.errorStatusOther;
    return errorStatusCb.call(this, err, context);
  }

  errorStatusNone(err) {
    return DepsService.ErrorNotificationService.notifyUnknownServerError().then(() => Promise.reject(new Error(err)));
  }

  errorStatus400(err, context) {
    const errorCode = this.getErrorCode(err);
    err = this.setErrorCode(err, errorCode);
    return DepsService.ErrorNotificationService.notifyServerError(err, context).then((response) => Promise.reject({ response, ...err }));
  }

  errorStatus409(err) {
    const errorCode = this.getErrorCode(err);
    err = this.setErrorCode(err, errorCode);
    return DepsService.ErrorNotificationService.notifyStatus409().then(() => Promise.reject(err));
  }

  errorStatus408(err, context) {
    const errorCode = this.getErrorCode(err);
    err = this.setErrorCode(err, errorCode);
    
    return DepsService.ErrorNotificationService.notifyStatus408(err, context).then((response) => {
      this.$state.go('home-view');
      return Promise.reject({ response, ...err });
    });
  }

  errorStatusOther(err, context) {
    return DepsService.ErrorNotificationService.notifyServerError(err, context).then((response) => {
      const errCode = _.get(err, 'data.errors[0].code') || _.get(this, 'config.errorCodes.UNEXPECTED_SERVER_ERROR');
      const errSkipRedirect = _.get(err, 'data.skipRedirect');
      const shouldRedirect = errCode >= 1000 && !errSkipRedirect;

      if (shouldRedirect) {
        this.$state.go('home-view');
      }
      return Promise.reject({ response, ...err });
    });
  }
}

export default ErrorService;



// WEBPACK FOOTER //
// ./src/modules/utils/rest/error/error-service.js